export const CampaignActionTypes = {
    UNSUBSCRIBE : "UNSUBSCRIBE"
}